import Window from "../window/Window.jsx";
import Tooltip from "../tooltip/Tooltip.jsx";

function Social({ data, functions }) {
  return (
    <Window
      id="social"
      title="Centres d'intérêt"
    >
      {data.map((d, i) => (
        <section key={d.titre + "-" + i}>
          <h3>{d.titre}</h3>
          <p>{d.description}</p>
          <ul>
            {d.exemples?.map((icon, i) => (
              <li key={icon.nom + "-" + i} className="tooltip_hover">
                <a href={icon.url}>
                  <img src={icon.image} />
                </a>
                <Tooltip>{icon.nom}</Tooltip>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </Window>
  );
}

export default Social;
